"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomDifficulty = exports.difficultyGenerators = exports.createExtremeDifficulty = exports.createVeryHardDifficulty = exports.createHardDifficulty = exports.createMediumDifficulty = exports.createEasyDifficulty = exports.createVeryEasyDifficulty = void 0;
var rogueGenHouse_sizes_1 = require("./rogueGenHouse_sizes");
var createVeryEasyDifficulty = function () {
    return {
        difficultyName: 'Very Easy',
        numBigFires: 3,
        numSmallFires: 3,
        numPets: 3,
        fireSpreadChance: 0.45,
        fireGrowChance: 0.2,
        fireHitChance: 0.25,
        maxFireTimer: 12,
        houseDamageChance: 0.25,
        roomSpawnItemChance: 0.1,
    };
};
exports.createVeryEasyDifficulty = createVeryEasyDifficulty;
var createEasyDifficulty = function () {
    return {
        difficultyName: 'Easy',
        numBigFires: 5,
        numSmallFires: 5,
        numPets: 6,
        fireSpreadChance: 0.5,
        fireGrowChance: 0.25,
        fireHitChance: 0.25,
        maxFireTimer: 10,
        houseDamageChance: 0.5,
        roomSpawnItemChance: 0.15,
    };
};
exports.createEasyDifficulty = createEasyDifficulty;
var createMediumDifficulty = function () {
    return {
        difficultyName: 'Medium',
        numBigFires: 5,
        numSmallFires: 5,
        numPets: 8,
        fireSpreadChance: 0.6,
        fireGrowChance: 0.35,
        fireHitChance: 0.35,
        maxFireTimer: 10,
        houseDamageChance: 0.6,
        roomSpawnItemChance: 0.15,
    };
};
exports.createMediumDifficulty = createMediumDifficulty;
var createHardDifficulty = function () {
    return {
        difficultyName: 'Hard',
        numBigFires: 6,
        numSmallFires: 6,
        numPets: 10,
        fireSpreadChance: 0.7,
        fireGrowChance: 0.4,
        fireHitChance: 0.4,
        maxFireTimer: 8,
        houseDamageChance: 0.65,
        roomSpawnItemChance: 0.15,
    };
};
exports.createHardDifficulty = createHardDifficulty;
var createVeryHardDifficulty = function () {
    return {
        difficultyName: 'Very Hard',
        numBigFires: 7,
        numSmallFires: 7,
        numPets: 12,
        fireSpreadChance: 0.75,
        fireGrowChance: 0.45,
        fireHitChance: 0.5,
        maxFireTimer: 7,
        houseDamageChance: 0.75,
        roomSpawnItemChance: 0.15,
    };
};
exports.createVeryHardDifficulty = createVeryHardDifficulty;
var createExtremeDifficulty = function () {
    return {
        difficultyName: 'Extreme',
        numBigFires: 8,
        numSmallFires: 8,
        numPets: 15,
        fireSpreadChance: 0.75,
        fireGrowChance: 0.5,
        fireHitChance: 0.75,
        maxFireTimer: 6,
        houseDamageChance: 0.75,
        roomSpawnItemChance: 0.15,
    };
};
exports.createExtremeDifficulty = createExtremeDifficulty;
exports.difficultyGenerators = [
    exports.createVeryEasyDifficulty,
    exports.createEasyDifficulty,
    exports.createMediumDifficulty,
    exports.createHardDifficulty,
    exports.createVeryHardDifficulty,
    exports.createExtremeDifficulty,
];
var getRandomDifficulty = function (levelNum, levelAdjust) {
    return (0, rogueGenHouse_sizes_1.getLevelArrayIdx)(exports.difficultyGenerators, levelNum, levelAdjust);
    // let numSizes = difficultyGenerators.length
    // let numLevels = 10
    // let base = (levelNum + levelAdjust) * (numSizes / numLevels) - 1
    // base += rando.i(-1, 1)
    // base = mathUtils.clamp(base, 0, numSizes - 1)
    // return difficultyGenerators[base]
};
exports.getRandomDifficulty = getRandomDifficulty;
